"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_EXPERIENCES = exports.defaultExperience = exports.REGIME_ON_CONSENT_EXPIRY = exports.REGIME_CONSENT_EXPIRY = exports.REGIME_LANGUAGES = exports.REGIME_REGIONS = void 0;
// main
const type_utils_1 = require("@transcend-io/type-utils");
// local
const privacyRegime_1 = require("./enums/privacyRegime");
const viewState_1 = require("./enums/viewState");
const ui_1 = require("./ui");
const constants_1 = require("./constants");
const enums_1 = require("./enums");
// default to []
// Don't put this into constants or you will regret it (per the constants.ts warning)
exports.REGIME_REGIONS = {
    CPRA: [{ country: 'US', countrySubDivision: 'US-CA' }],
    GDPR: [
        { country: 'EU' },
        { country: 'GB' },
        { country: 'NO' },
        { country: 'IS' },
        { country: 'LI' },
    ],
    LGPD: [{ country: 'BR' }],
    CDPA: [{ country: 'US', countrySubDivision: 'US-VA' }],
    CPA: [{ country: 'US', countrySubDivision: 'US-CO' }],
    UCPA: [{ country: 'US', countrySubDivision: 'US-UT' }],
    NEVADA_SB220: [{ country: 'US', countrySubDivision: 'US-NV' }],
    nFADP: [{ country: 'CH' }],
    US_DNSS: [
        { country: 'US', countrySubDivision: 'US-CA' },
        { country: 'US', countrySubDivision: 'US-VA' },
        { country: 'US', countrySubDivision: 'US-CO' },
        { country: 'US', countrySubDivision: 'US-NV' },
        { country: 'US', countrySubDivision: 'US-TX' },
        { country: 'US', countrySubDivision: 'US-CT' },
        { country: 'US', countrySubDivision: 'US-OR' },
        { country: 'US', countrySubDivision: 'US-MT' },
        { country: 'US', countrySubDivision: 'US-UT' },
        { country: 'US', countrySubDivision: 'US-IA' },
        { country: 'US', countrySubDivision: 'US-DE' },
        { country: 'US', countrySubDivision: 'US-NH' },
        { country: 'US', countrySubDivision: 'US-NE' },
        { country: 'US', countrySubDivision: 'US-NJ' },
    ],
};
// default to []
// Don't put this into constants or you will regret it (per the constants.ts warning)
exports.REGIME_LANGUAGES = {
    GDPR: [
        enums_1.BrowserLanguage['Bulgarian (Bulgaria)'],
        enums_1.BrowserLanguage['Croatian (Croatia)'],
        enums_1.BrowserLanguage['Czech (Czech Republic)'],
        enums_1.BrowserLanguage['Danish (Denmark)'],
        enums_1.BrowserLanguage['Dutch (Belgium)'],
        enums_1.BrowserLanguage['Dutch (Netherlands)'],
        enums_1.BrowserLanguage['English (Ireland)'],
        enums_1.BrowserLanguage['Estonian (Estonia)'],
        enums_1.BrowserLanguage['Finnish (Finland)'],
        enums_1.BrowserLanguage['French (Belgium)'],
        enums_1.BrowserLanguage['French (France)'],
        enums_1.BrowserLanguage['French (Luxembourg)'],
        enums_1.BrowserLanguage['German (Austria)'],
        enums_1.BrowserLanguage['German (Germany)'],
        enums_1.BrowserLanguage['German (Liechtenstein)'],
        enums_1.BrowserLanguage['German (Luxembourg)'],
        enums_1.BrowserLanguage['Greek (Greece)'],
        enums_1.BrowserLanguage['Hungarian (Hungary)'],
        enums_1.BrowserLanguage['Icelandic (Iceland)'],
        enums_1.BrowserLanguage['Irish (Ireland)'],
        enums_1.BrowserLanguage['Italian (Italy)'],
        enums_1.BrowserLanguage['Latvian (Latvia)'],
        enums_1.BrowserLanguage['Lithuanian (Lithuania)'],
        enums_1.BrowserLanguage['Maltese (Malta)'],
        enums_1.BrowserLanguage['Norwegian (Norway)'],
        enums_1.BrowserLanguage['Norwegian Bokmål (Norway)'],
        enums_1.BrowserLanguage['Norwegian Nynorsk (Norway)'],
        enums_1.BrowserLanguage['Polish (Poland)'],
        enums_1.BrowserLanguage['Portuguese (Portugal)'],
        enums_1.BrowserLanguage['Romanian (Romania)'],
        enums_1.BrowserLanguage['Slovak (Slovakia)'],
        enums_1.BrowserLanguage['Slovenian (Slovenia)'],
        enums_1.BrowserLanguage['Spanish (Espa\u00f1a)'],
        enums_1.BrowserLanguage['Swedish (Finland)'],
        enums_1.BrowserLanguage['Swedish (Finland)'],
        enums_1.BrowserLanguage['Swedish (Sweden)'],
    ],
    LGPD: [enums_1.BrowserLanguage['Portuguese (Brazil)']],
    nFADP: [
        enums_1.BrowserLanguage['German (Switzerland)'],
        enums_1.BrowserLanguage['French (Switzerland)'],
        enums_1.BrowserLanguage['Italian (Switzerland)'],
        enums_1.BrowserLanguage['English (Switzerland)'],
        enums_1.BrowserLanguage['Portuguese (Switzerland)'],
        enums_1.BrowserLanguage['Swiss German (Switzerland)'],
    ],
};
// default to 0
exports.REGIME_CONSENT_EXPIRY = {
    GDPR: 12,
};
// default to prompt
exports.REGIME_ON_CONSENT_EXPIRY = {
    GDPR: enums_1.OnConsentExpiry.ResetOptIns,
};
/**
 * construct default experience for regime
 * @param regime - regime
 * @returns ExperienceInput
 */
function defaultExperience(regime) {
    var _a, _b, _c, _d, _e, _f, _g;
    const isUnknown = regime === 'Unknown';
    const regimeEnum = privacyRegime_1.PrivacyRegimeEnum[regime];
    return {
        name: regime,
        displayName: regime,
        regions: (_a = exports.REGIME_REGIONS[regime]) !== null && _a !== void 0 ? _a : [],
        operator: isUnknown ? enums_1.RegionsOperator.NotIn : enums_1.RegionsOperator.In,
        displayPriority: (_b = constants_1.REGIME_DISPLAY_PRIORITY[regime]) !== null && _b !== void 0 ? _b : 20,
        viewState: (_c = ui_1.DEFAULT_VIEW_STATE_BY_PRIVACY_REGIME[regimeEnum]) !== null && _c !== void 0 ? _c : viewState_1.InitialViewState.Hidden,
        browserLanguages: (_d = exports.REGIME_LANGUAGES[regime]) !== null && _d !== void 0 ? _d : [],
        browserTimeZones: (_e = constants_1.REGIME_TIMEZONES[regime]) !== null && _e !== void 0 ? _e : [],
        experiencePurposeInputs: constants_1.DEFAULT_EXPERIENCE_PURPOSE_SCOPES[regime].map((purpose) => {
            var _a, _b;
            return ({
                purpose,
                defaultOptOut: (_b = (_a = constants_1.DEFAULT_EXPERIENCE_PURPOSE_OPT_OUTS[regime]) === null || _a === void 0 ? void 0 : _a.includes(purpose)) !== null && _b !== void 0 ? _b : false,
            });
        }),
        consentExpiry: (_f = exports.REGIME_CONSENT_EXPIRY[regime]) !== null && _f !== void 0 ? _f : 0,
        onConsentExpiry: (_g = exports.REGIME_ON_CONSENT_EXPIRY[regime]) !== null && _g !== void 0 ? _g : enums_1.OnConsentExpiry.Prompt,
    };
}
exports.defaultExperience = defaultExperience;
exports.DEFAULT_EXPERIENCES = (0, type_utils_1.applyEnum)(privacyRegime_1.PrivacyRegimeEnum, defaultExperience);
//# sourceMappingURL=experience.js.map